const mrpPurchaseHeader = [
  {
    group: 'Alertas',
    columns: [
      {
        name: 'Comprar',
        id: 'alerta-comprar',
        show: true
      },
      {
        name: 'Receber',
        id: 'alerta-receber',
        show: true
      }
    ]
  },
  {
    group: 'Centro',
    columns: [
      {
        name: 'Código',
        id: 'centro-id',
        show: true
      }
    ]
  },
  {
    group: 'Produto',
    columns: [
      {
        name: 'Código',
        id: 'produto-id',
        show: true
      },
      {
        name: 'Material',
        id: 'produto-material',
        show: true
      },
      {
        name: 'Categoria',
        id: 'produto-categoria',
        show: true
      },
      {
        name: 'Sub Categoria',
        id: 'produto-subcategoria',
        show: true
      },
      {
        name: 'Curva',
        id: 'produto-curva-abc',
        show: true
      }
      // {
      //   name: 'Curva ABC Empresa',
      //   id: 'produto-curva-abc-empresa',
      //   show: true
      // }
    ]
  },
  {
    group: 'Fornecedor',
    columns: [
      {
        name: 'Código',
        id: 'fornecedor-id',
        show: true
      },
      {
        name: 'Nome',
        id: 'fornecedor-nome',
        show: true
      },
      {
        name: 'LeadTime',
        id: 'fornecedor-leadtime',
        show: true
      }
    ]
  },
  {
    group: 'Previsões',
    columns: [
      {
        name: 'VM Retira Centro (4M)',
        id: 'previsoes-vendamedia',
        show: true,
        isNumeric: true
      },
      {
        name: 'Estoque Mínimo',
        id: 'previsoes-estoqueminimo',
        show: true,
        isNumeric: true
      }
    ]
  },
  {
    group: 'Estoque',
    columns: [
      {
        name: 'Atual',
        id: 'estoque-atual',
        show: true,
        isNumeric: true
      },
      {
        name: 'Transito',
        id: 'estoque-transito',
        show: true,
        isNumeric: true
      },
      {
        name: 'Cobertura Atual',
        id: 'estoque-coberturaatual',
        show: true,
        isNumeric: true
      },
      {
        name: 'Dep. 16',
        id: 'estoque-dep16',
        show: true,
        isNumeric: true
      },
      {
        name: 'Alvo',
        id: 'estoque-alvo',
        show: true,
        isNumeric: true
      },
      {
        name: 'Alvo Dias',
        id: 'estoque-alvoDias',
        show: true,
        isNumeric: true
      }
    ]
  }
]

export default mrpPurchaseHeader
